<template>
  <EditTaskPage v-if="canShowTaskPage" ref="editTaskPage"
                :read-only="true" :data="task" :search-token="searchToken"
                :can-accept-task="canAcceptTask" :secret-key="key" @task-accepted="taskAccepted">
  </EditTaskPage>
</template>

<script>
import EditTaskPage from "@/components/pages/task-planning/EditTaskPage.vue";
import {actions, mutations} from "@/assets/js/vue/vuex/actions";

export default {
  components: {EditTaskPage},
  name: 'ViewOnlyTaskPage',
  props: {
    searchToken: String,
    id: String
  },
  data() {
    return {
      task: null,
      key: null
    }
  },
  computed: {
    canShowTaskPage() {
      return this.task;
    },
    canAcceptTask() {
      return !this.task?.acceptedByDriver;
    }
  },
  mounted: async function () {
    this.key = this.$route.query.key;
    const result = await this.$store.dispatch(actions.GET_TASK_VIEW_ONLY, {id: this.id, key: this.key});
    this.$store.commit(mutations.SET_USER_GEO_FENCES, result.geoFences);
    if (result.vehicle) {
      this.$store.commit(mutations.SET_VEHICLES, [result.vehicle]);
    }
    if (result.driver) {
      this.$store.commit(mutations.SET_DRIVERS, [result.driver]);
    }
    if (result.device) {
      this.$store.commit(mutations.SET_DEVICES, [result.device]);
    }
    if (result.position) {
      this.$store.commit(mutations.APPEND_POSITIONS, [result.position]);
    }
    if (result.tripsData) {
      this.$store.commit(mutations.SET_TRIPS_DATA, result.tripsData);
    }
    if (result.tripsRecordPositions) {
      this.$store.commit(mutations.SET_TRIPS_RECORD_POSITIONS, result.tripsRecordPositions);
    }
    this.task = result.task;
    if (result.tripsData && result.tripsRecordPositions) {
      setTimeout(() => this.$refs.editTaskPage.initTripsForMap(result.tripsData, result.tripsRecordPositions), 500);
    }
  },
  methods: {
    taskAccepted() {
      this.task.acceptedByDriver = true;
    }
  }
}
</script>

<style scoped lang="scss">

</style>